import React, { useCallback, useEffect, useState } from "react";
import useSize from "../../../../Utils/useSize/useSize";

import moment from "moment";
import Backend from "../../../../Backend/Backend";
import toast from "react-hot-toast";

import Filter from "./Filter/Filter";
import TotalCard from "./TotalCard/TotalCard";
import Loading from "../../../../Utils/Loading/Loading";
import NotFound from "../../../../Utils/NotFound/NotFound";
import Menu from "./Menu/Menu";
import InterestCard from "./InterestCard";

const backend = await new Backend().init();

export default function InterestBill() {
  const windowSize = useSize();

  const [loading, setLoading] = useState(false);

  const [interest, setInterest] = useState([]);

  const [interestAmount, setInterestAmount] = useState(0);
  const [depositInterestAmt, setDepositInterestAmt] = useState(0);

  const loadInterest = useCallback(async (start, end) => {
    setLoading(true);
    try {
      const payload = {
        server: localStorage.getItem("server"),
        id: localStorage.getItem("id"),
        username: localStorage.getItem("username"),
        token: localStorage.getItem("token"),
        user_id: localStorage.getItem("id"),
        start: start || moment().startOf("week"),
        end: end || moment().endOf("week"),
      };

      const response = await backend.interest_bill(payload);
      if (response.error === "False") {
        setInterest(response.interest || []);
        setInterestAmount(response.interest_amount || 0);
        setDepositInterestAmt(response.deposit_interest_amt || 0);
      } else {
        toast.error(response.message || "Failed to load login logs");
      }
    } catch (err) {
      toast.error("Something went wrong while loading logs");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadInterest();
  }, [loadInterest]);

  return (
    <div className="w-full">
      <Filter onRefresh={loadInterest} />

      <TotalCard
        interestAmount={interestAmount}
        depositInterestAmt={depositInterestAmt}
      />

      <Menu />

      {/* LEDGER LIST SECTION */}
      <div
        key={interest}
        className="flex flex-col"
        style={{ height: windowSize[1] - 265 }}
      >
        {loading ? (
          <div className="loadingContainer">
            <Loading height={windowSize[1] - 265} />
          </div>
        ) : interest.length > 0 ? (
          <div
            className="overflow-y-scroll"
            style={{ height: windowSize[1] - 265 }}
          >
            {interest.map((item) => (
              <InterestCard key={item.id} item={item} />
            ))}
          </div>
        ) : (
          <NotFound
            height={windowSize[1] - 265}
            title={"Nothing here"}
            subtext={"No Interest Bill Found."}
          />
        )}
      </div>
    </div>
  );
}
